export default __webpack_public_path__ + "static/media/quiz-bg.cf72dde9.png";